// Formatting utilities for currency, errors, etc.
export const asCurrency = (amount, currency = 'USD', locale = 'en-US') => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
};

export const pickErrorMessage = (error) => {
    if (!error) return 'An unknown error occurred';

    if (typeof error === 'string') return error;

    if (error.response?.data?.message) {
        return error.response.data.message;
    }

    if (error.message) {
        return error.message;
    }

    return 'An unknown error occurred';
};
